/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47867Req {
  
  /** 项目编号 */
  projectNo?: string;
  /** 项目名称 */
  projectName?: string;
  /** 里程牌计划列表 ,ProjectPlanEditParam */
  planList?: any[];
};



export type API47867Res = {};


// 47867 编辑项目计划(里程碑) - 逆行

export interface IUsePostAPI47867Return {
  /** 编辑项目计划(里程碑) - 逆行: 接口请求状态 */
  isAPI47867Loading: boolean;
  /** 编辑项目计划(里程碑) - 逆行: 接口请求返回数据 */
  dataAPI47867: API47867Res;
  /**  编辑项目计划(里程碑) - 逆行: 接口数据请求方法 */
  fetchAPI47867Data:  (inputs: API47867Req, config?: YWRequestConfig) => Promise<API47867Res>;
  /** 编辑项目计划(里程碑) - 逆行: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47867 = ():IUsePostAPI47867Return => {
  let isMount = true;
  const [isAPI47867Loading, setIsAPI47867Loading] = useState(false);
  const [dataAPI47867, setDataAPI47867] = useState<API47867Res>({} as API47867Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/saveOrEdit`;

  const fetchAPI47867Data = async (inputs: API47867Req, config?: YWRequestConfig): Promise<API47867Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47867Req>) || {}) as API47867Req;
    
  
    if ( isMount ) {
      setIsAPI47867Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47867Res>(`${basePath}/corp-admin/project/plan/saveOrEdit`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47867(res || {} as API47867Res);
        setIsAPI47867Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47867Loading(false);
      }
      return false as unknown as API47867Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47867Loading,
    dataAPI47867,
    fetchAPI47867Data,
    requestUrl,
  }
}

